/* eslint-disable */

class Header {
    constructor() {
        this.header = document.querySelector('.header[role="banner"]');

        this.container = document.querySelector('.site-navigation--mobile');

        this.desktopContainer = document.querySelector('.site-navigation');

        this.desktopButtons = null;
    }

    init(helpers, modalDialog) {
        const self = this;

        self.helpers = helpers;

        self.modalDialog = modalDialog;

        if(!self.container) {
            return;
        }

        (async() => {
            while(
                !document.querySelector('html').hasAttribute('data-progressive-enhancements')
                || !document.querySelector('html').getAttribute('data-progressive-enhancements').includes('disclosure')
            ) {
                await new Promise(resolve => setTimeout(resolve, 50));
            }

            self.enhanceForMobile(self);
            self.enhanceForDesktop(self);
        })();
    }

    collapseExpandedDesktopButtons(e, self) {
        if('BUTTON' !== e.currentTarget.tagName) {
            return;
        }

        if(!e.currentTarget.hasAttribute('aria-expanded')) {
            return;
        }

        if('true' !== e.currentTarget.getAttribute('aria-expanded')) {
            return;
        }

        let expandedDesktopButtons = Array.prototype.slice.call(self.desktopButtons, 0).filter(button =>
            ('true' === button.getAttribute('aria-expanded'))
            && (e.currentTarget !== button)
            );

        for(let button of expandedDesktopButtons) {
            let buttonText = button.textContent;

            button.click();

            setTimeout(function() {
                wp.a11y.speak(wp.i18n.sprintf(i18n.Header.subMenuAutomaticallyCollapsed, buttonText));
            }, 1000);
        }
    }

    enhanceForDesktop(self) {
        self.desktopButtons = self.desktopContainer.querySelectorAll('section[data-progressive-enhancement][data-progressive-enhancement-type="disclosure"]  > h4 > button');


        for(let button of self.desktopButtons) {
            button.addEventListener('click', function(e) {
                self.collapseExpandedDesktopButtons(e, self);
            });
        }

        window.addEventListener('keyup', e => {
            if(
                !document.activeElement.closest('.site-navigation section[data-progressive-enhancement][data-progressive-enhancement-type="disclosure"]')
            ) {
                return;
            }

            if('Escape' !== e.key) {
                return;
            }

            let nearestButton = document.activeElement.closest('.site-navigation section[data-progressive-enhancement][data-progressive-enhancement-type="disclosure"]').querySelector('h4 > button[aria-expanded="true"]');

            if(!nearestButton) {
                return;
            }

            e.stopImmediatePropagation();

            nearestButton.focus();

            nearestButton.click();
        });
    }

    enhanceForMobile(self) {
        let closeButton,
            menu = self.container.querySelector('.js-site-navigation-menu'),
            menuHeading = document.createElement('h2'),
            menuHeadingAdditionalSpan = document.createElement('span'),
            siteMapLink = self.container.querySelector('.js-site-map-link'),
            triggerButton;

        siteMapLink.parentElement.removeChild(siteMapLink);

        menuHeading.id = menu.id + '__heading';
        menu.setAttribute('aria-labelledby', menuHeading.id);;
        menu.setAttribute('data-progressive-enhancement', 'off');
        menu.setAttribute('data-progressive-enhancement-type', 'modal-dialog');
        menu.appendChild(menuHeading);

        menuHeading.appendChild(document.createTextNode(i18n.Header.menu));

        menuHeading.appendChild(menuHeadingAdditionalSpan);

        menuHeadingAdditionalSpan.classList.add('visually-hidden');

        menuHeadingAdditionalSpan.appendChild(document.createTextNode(' - ' + i18n.Header.menuHeadingAdditionalText));

        self.modalDialog.enhance(menu, self.modalDialog);

        document.documentElement.dataset.siteNavigationMenuStatus = 'closed';

        triggerButton = self.container.querySelector('.js-modal-dialog-trigger-button');
        closeButton = document.querySelector('#modal-dialog--menu-search-site-navigation-and-preferences .js-modal-dialog__close-button');

        triggerButton.addEventListener('click', function() {
            if('closed' !== document.documentElement.dataset.siteNavigationMenuStatus) {
                return;
            }

            document.documentElement.dataset.siteNavigationMenuStatus = 'open';
        });

        closeButton.addEventListener('click', function() {
            if('open' !== document.documentElement.dataset.siteNavigationMenuStatus) {
                return;
            }

            document.documentElement.dataset.siteNavigationMenuStatus = 'closed';
        });

    }
}

export default Header;
